import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Layout Display Mode Icons - Block, Flex, Grid selectors
// =============================================================================

export function LayoutBlock(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "LayoutBlock",
    viewBox: "0 0 20 16",
    path: (
      <rect
        x="2"
        y="2"
        width="16"
        height="12"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function LayoutFlex(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "LayoutFlex",
    viewBox: "0 0 20 16",
    path: (
      <>
        <rect
          x="2"
          y="2"
          width="7"
          height="12"
          rx="1"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="2"
          width="7"
          height="12"
          rx="1"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function LayoutGrid(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "LayoutGrid",
    viewBox: "0 0 20 16",
    path: (
      <>
        <rect
          x="2"
          y="2"
          width="7"
          height="5"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="2"
          width="7"
          height="5"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="2"
          y="9"
          width="7"
          height="5"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="9"
          width="7"
          height="5"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
